import apiConfig from "src/utils/apiConfig";

export const GET_STATUS_REPORT = "statusreport/fetchStatusReportRequest";

export const GetStatusReport = (fromdate: any, todate: any) => {
  let endpoint = `${apiConfig.GETSTATUSREPORT}/?fromdate=${fromdate}&todate=${todate}`;

  const apiobject = {
    method: "GET",
    authentication: true,
    endpoint,
  };

  return {
    type: GET_STATUS_REPORT,
    payload: apiobject,
  };
};
